<template>
  <Row>
    <Col cols="12 col-sm-8">
      <Table
        class="ml-3"
        :headers="headers"
        :items="items"
        hide-default-footer
      />
    </Col>
  </Row>
</template>

<script>
import { Table, Row, Col } from '@locaweb/design-system-vue'
import { headers, items } from './helpTableContent'

export default {
  name: 'HelpTable',
  components: {
    Row,
    Col,
    Table
  },
  data: () => ({
    headers: headers(),
    items: items()
  })
}
</script>
